export default (value: any) => {
  if (typeof value === "undefined" || value === null || value === "") {
    return true;
  }

  return !/^\s+$/g.test(value);
};
